import { firebase, authFXAuthProvider } from "../firebase/firebase";
import Cookies from "js-cookie";
import { authfxLogout } from "../actions/authfx";

export const login = (uid, currentUser) => ({
    type: 'LOGIN',
    uid,
    currentUser
});

export const startLogin = () => {
    return () => {
        return firebase.auth().signInWithRedirect(authFXAuthProvider);
    };
};

export const logout = () => ({
    type: 'LOGOUT'
});

export const startLogout = () => {
    return () => {
        authfxLogout();
        return firebase.auth().signOut();
    };
};

export const deleteAccount = () => {
    authfxLogout();
    firebase.auth().currentUser.delete();
    return () => {
        return firebase.auth().signOut();
    };
}


// WEBPACK FOOTER //
// ./src/actions/auth.js